import styled from 'styled-components';

import { IOcAppTheme, OcColors } from '../../config/ocTheme';

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
  border-radius: 4px;
  line-height: 1;
  background-color: ${({ theme }) => OcColors.bg2 || theme.color.betaBadgeBG};
  color: ${({ theme }) => OcColors.metaText || theme.color.betaBadge};
  font-size: ${({ theme }) => (theme as IOcAppTheme).font.size.xSmall || '12px'};
`;

export const IconSvg = styled.svg<{ $color: string }>`
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  color: ${({ $color }) => $color};
`;

